import React from "react";
import { useParams } from "react-router-dom";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import "./Allproduct2.css";

const VeeamPage = () => {
  const { type } = useParams();

  const veeamPages = {
    "veeam-vvar": {
      title: "Veeam VVAR",
      url: "https://wcs-backupm365-proscope.veeampartnermktg.com/Home",
    },
    "veeam-vcsp": {
      title: "Veeam VCSP",
      url: "https://wcs-veeamdataplatform-proscope.swcontentsyndication.com/Homepage-EN",
    },
  };

  const page = veeamPages[type];

  if (!page) {
    return (
      <>
        <Header />
        <div className="veeam-page-container">
          <h1>Page not found</h1>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <div className="veeam-page-container">

        <div className="sw_frame_div">
          <iframe
            title={page.title}
            className="sw_frame"
            allow-page-override="true"
            add-utm-params="true"
            src={page.url}
          ></iframe>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default VeeamPage;